"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Display: function() {
        return _Display.Display;
    },
    displayClassNames: function() {
        return _useDisplayStylesstyles.displayClassNames;
    }
});
const _Display = require("./Display");
const _useDisplayStylesstyles = require("./useDisplayStyles.styles");
